import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PortalService } from '../../../../../../services/portal.service';
import { EnrollmentFormService } from '../../../../../../services/EnrollmentFormService';
import { EnrollmentComponent } from '../enrollment/enrollment.component';
import { AddressValidationComponent } from '../../../modals/address-validation/address-validation.component';
import { MatDialog } from '@angular/material/dialog';
import { TelemetryService } from '../../../../../../services/telemetry.service';

@Component({
  selector: 'app-physician-info',
  templateUrl: './physician-info.component.html',
  styleUrls: ['./physician-info.component.scss']
})
export class PhysicianInfoComponent implements OnInit {
  physicianForm!: FormGroup;
  physicianSubgroup: FormGroup;
  states: any; // Replace with real states
  enrollmentId: any;
  currentSequenceStep: string;
  isLoading = false;
  editFlow = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private portalService: PortalService,
    private router: Router,
    private efs: EnrollmentFormService,
    private route: ActivatedRoute,
    private enrollmentComponent: EnrollmentComponent,
    private dialog: MatDialog,
    private telemetryService: TelemetryService) {
    this.physicianForm = this.efs.enrollmentForm as FormGroup;
  }

  ngOnInit(): void {
    this.physicianSubgroup = new FormGroup({
      physicianFirstName: this.physicianForm.get('physicianFirstName'),
      physicianLastName: this.physicianForm.get('physicianLastName'),
      physicianPhone: this.physicianForm.get('physicianPhone'),
      physicianEmail: this.physicianForm.get('physicianEmail'),
      physicianFax: this.physicianForm.get('physicianFax'),
      addressLine1: this.physicianForm.get('physicianAddress1'),
      addressLine2: this.physicianForm.get('physicianAddress2'),
      city: this.physicianForm.get('physicianCity'),
      state: this.physicianForm.get('physicianState'),
      zipCode: this.physicianForm.get('physicianZip'),
    });
    this.currentSequenceStep = localStorage.getItem('CurrentEnrollmentStep');
    this.efs.enrollmentID$.subscribe((id) => {
      this.enrollmentId = id;
      console.log('Received Enrollment ID:', id);
    });
    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.enrollmentId = params.get('id');
        this.editFlow = true;
      }
    });

    this.portalService.getStatesList().subscribe({
      next: (data) => {
        this.states = data;
      },
      error: (err) => {
        console.error('Error loading states:', err);
      }
    });
  }

  get nextStep() {
    return this.efs.getNextStep();
  }

  createEnrollment(isSaveAndExit: boolean){
    this.isLoading = true;
    this.portalService.createEnrollment(this.physicianForm.value, this.enrollmentId).subscribe((value: any) => {
      console.log(value);
      this.isLoading = false;
      this.efs.patchEnrollmentForm(value);
      if (isSaveAndExit) {
        this.efs.resetForm();
        this.router.navigate(['/submissions'], { relativeTo: this.activatedRoute });
      } else {
        if (this.editFlow) {
          this.router.navigate([`../${this.nextStep.enrollmentRoute}`], { relativeTo: this.activatedRoute });
          this.enrollmentComponent.setCurrentStep(this.nextStep.enrollmentStepName,'true');
        } else {
          this.enrollmentComponent.setCurrentStep(this.nextStep.enrollmentStepName);
        }
      }
    });
  }

  onSave(isSaveAndExit = false): void {
    if(!isSaveAndExit) {
			this.telemetryService.logEvent('Next Button Clicked', {
				step: this.nextStep.enrollmentStepName,
				timestamp: new Date().toISOString(),
			});
		}

    this.isLoading = true;
    this.physicianForm.patchValue({
      lastEnrollmentStep: this.currentSequenceStep
    });
    if (this.physicianForm.value) {
      //this.createEnrollment(isSaveAndExit);

      const currentShippingAddress: any = {
        'address1': this.physicianForm.value.physicianAddress1,
        'address2': this.physicianForm.value.physicianAddress2,
        'city': this.physicianForm.value.physicianCity,
        'state': this.physicianForm.value.physicianState,
        'zip': this.physicianForm.value.physicianZip
      }
      this.portalService.validateAddress(currentShippingAddress).subscribe(response => {
        if (!response.data.status) {
          this.isLoading = false;
          const dialogRef = this.dialog.open(AddressValidationComponent, {
            data: currentShippingAddress,
            maxWidth: '30vw',
            autoFocus: false,
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe(isConfirm => {
            if (isConfirm) {
              this.createEnrollment(isSaveAndExit);
            }else{
              return;
            }
          })
        } else {
          this.isLoading = false;
          this.createEnrollment(isSaveAndExit);
        }
      });
    }
  }
}
